// extracted by mini-css-extract-plugin
module.exports = {"privacy":"privacy_privacy__7T8bs","description":"privacy_description__YCfSy","content":"privacy_content__7PhGc"};